import { useCallback } from 'react';

import { useConfig } from '../defaultConfig';
import { BillingSummary } from '../generated-types';

export default () => {
    const {
        links: { extraPayment },
    } = useConfig();
    return useCallback(
        (billingSummary: BillingSummary) => {
            const returnUrl = window.location.href;
            const kid = billingSummary.kidNumber;
            const receiverAccountNumber = billingSummary.paymentBankAccountNumber;

            return `${extraPayment?.url}?receiverAccountNumber=${receiverAccountNumber}&kid=${kid}&returnUrl=${returnUrl}`;
        },
        [extraPayment?.url],
    );
};
